export const GET_SHOPS = 'GET_SHOPS';
export const NEW_SHOP_MODAL_OPENED = 'NEW_SHOP_MODAL_OPENED';
export const ADD_SHOP = 'ADD_SHOP';
export const SELECT_LAST_ADDED_SHOP = 'SELECT_LAST_ADDED_SHOP';
export const SHOP_INFO_MODAL_OPENED = 'SHOP_INFO_MODAL_OPENED'; 
export const SET_CURR_SHOP_ID = 'SET_CURR_SHOP_ID';
